// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"88ba4b20","455":"ddec8e1f","977":"51a27751"}[chunkId] + ".chunk.js";
};